

const Categorycard = (category) => {

  
  return (
    <div className="w-72 group relative flex flex-col items-center justify-center cursor-pointer">
      <img
        src={category.image}
        alt=""
        className="w-16 h-16 p-2 rounded-xl hover:scale-110 transition-transform duration-300"
      />
      <span className="mt-2 text-sm font-medium text-gray-700">
        {category.name}
      </span>
      <div className="absolute top-full mt-2 left-1/2 transform -translate-x-1/2 hidden group-hover:flex flex-col bg-white shadow-lg rounded-lg w-44 z-50 transition-all duration-200">
        {category.subcategories.map((item, index) => (
          <span
            key={index}
            className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-blue-600 transition-colors duration-200"
          >
            {item}
          </span>
        ))}
      </div>
    </div>
  );
};
export default Categorycard
